import React from 'react';
import Amenities from './Amenities';
import {ImageObj} from '../../../../types/ImageObj.types';
import Sustainability from './Sustainability';
import Service from './Service';
import Location from './Location';
import cn from './style.module.scss'
import DynamicTabs from '@components/DynamicTabs';
import WaldorfContainer from '@launch-components/WaldorfAstoriaLaunch/WaldorfContainer';
interface SpecificationTabProps {
  specificationTheme: {
    amenities: ImageObj[];
    services: ImageObj[];
    location: ImageObj[];
    sustainability: ImageObj[];
  };
  specificationMobileTheme: {
    amenities: ImageObj[];
    services: ImageObj[];
    location: ImageObj[];
    sustainability: ImageObj[];
  };
  t: any;
}
export default function SpecificationTab(props: SpecificationTabProps) {
  const {t} = props;

  const tabs = [
    {
      title: t['waldorfAminityLabel'],
      bgColor: '#272525',
      content: (
        <>
          <Amenities
            t={t}
            tabImages={props.specificationTheme.amenities}
            mobTabImages={props.specificationMobileTheme.amenities}
          />
        </>
      ),
    },
    {
      title: t['waldorfServiceLabel'],
      bgColor: '#272525',
      content: (
        <>
          <Service
            t={t}
            tabImages={props.specificationTheme.services}
            mobTabImages={props.specificationMobileTheme.services}
          />
        </>
      ),
    },
    {
      title: t['waldorfLocationLabel'],
      bgColor: '#272525',
      content: (
        <>
          <Location
            t={t}
            tabImages={props.specificationTheme.location}
            mobTabImages={props.specificationMobileTheme.location}
          />
        </>
      ),
    },
    {
      title: t['waldorfSustainabilityLabel'],
      bgColor: '#272525',
      content: (
        <>
          <Sustainability
            t={t}
            s
            tabImages={props.specificationTheme.sustainability}
            mobTabImages={props.specificationMobileTheme.sustainability}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <WaldorfContainer>
        <DynamicTabs
          tabs={tabs}
          className={cn.waldorfSpecification}
          tabClass={cn.waldorfTabElement}
          activeClassName={cn.activeLink}
        />
      </WaldorfContainer>
    </>
  );
}
